/**
 * 
 * @param date - JS Date object (optional)
 * @returns Date string in format YYYY-MM-DD 
 */
export const getShortDate = (date: Date = new Date()) =>  date.toJSON().slice(0, 10)